(() => {
  const ready = () => {
    const menus = Array.from(document.querySelectorAll('[data-awg-mobile-menu]'));

    const syncPageState = () => {
      const anyOpen = menus.some((menu) => menu.open);
      document.documentElement.classList.toggle('awg-menu-open', anyOpen);
    };

    menus.forEach((menu) => {
      const summary = menu.querySelector('summary');

      const syncMenu = () => {
        if (summary) summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
        syncPageState();
      };

      menu.addEventListener('toggle', syncMenu);

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          menu.removeAttribute('open');
          syncMenu();
        });
      });

      syncMenu();
    });

    document.addEventListener('click', (event) => {
      menus.forEach((menu) => {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
      syncPageState();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      menus.forEach((menu) => menu.removeAttribute('open'));
      syncPageState();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 900) {
        menus.forEach((menu) => menu.removeAttribute('open'));
        syncPageState();
      }
    });

    document.querySelectorAll('a[href="/#airwinks-size-guide"],a[href="/pages/custom-vent-covers#how-to-measure-custom-size"]').forEach((link) => {
      link.setAttribute('href', '/pages/how-to-measure');
    });

    const legacyNavLinks = document.querySelectorAll('.awp-desktop-nav a,.awp-mobile-menu__panel a,.awp-footer__column a,.awc-page__nav a,.awc-page__mobile-panel a,.awc-page__footer-column a,.awc-empty__categories a');
    legacyNavLinks.forEach((link) => {
      const href = link.getAttribute('href') || '';
      if (href.indexOf('/search?q=wall+vent') === 0) link.setAttribute('href', '/collections/wall-vent-covers');
      if (href === '/products/6x6-ceiling-vent-cover') link.setAttribute('href', '/collections/ceiling-vent-covers');
    });

    document.querySelectorAll('.awp-mini-trust span').forEach((item) => {
      if (item.textContent.trim().toLowerCase().includes('all-metal construction')) {
        item.innerHTML = '<b aria-hidden="true">✓</b> Installation-specific design';
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
